"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    root: {
      display: 'block'
    },
    group: {
      boxShadow: '0 3px 6px rgba(0, 0, 0, 0.03)',
      backgroundColor: '#ffffff',
      marginBottom: '12px',
      '&:first-of-type': {
        marginRight: '16px'
      },
      borderRadius: '10px'
    },
    title: {
      display: 'inline-block',
      padding: '14px'
    },
    secondaryTitle: {
      borderBottom: '1px solid #cccccc',
      fontSize: '14px',
      color: '#999999',
      paddingBottom: '10px'
    },
    value: {
      fontSize: '18px',
      fontWeight: typography.fontWeightLight,
      color: '#666666',
      marginBlockStart: '0.6em',
      textTransform: 'capitalize',
      justifyContent: 'space-between',
      display: 'flex'
    },
    rateValue: {
      fontSize: '18px',
      fontWeight: typography.fontWeightLight,
      color: '#1E8777',
      marginBlockStart: '0.6em'
    },
    key: {
      fontSize: '14px',
      fontWeight: typography.fontWeightSemiBold,
      color: '#212529',
      borderBottom: '1px solid #cccccc',
      paddingBottom: '10px',
      display: 'flex',
      justifyContent: 'space-between',
      flexGrow: 1
    },
    singleTitle: {
      display: 'inline-block'
    },
    alignLeft: {
      marginRight: 'auto'
    },
    alignRight: {
      marginLeft: 'auto'
    },
    alignCenter: {
      margin: 'auto'
    },
    flag: {
      display: 'block'
    },
    rightAligned: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };
}, {
  name: 'StatSummary'
});
exports.useStyles = useStyles;